import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { LoadingController } from "@ionic/angular";
import { Observable, pipe } from "rxjs";
import { tap } from "rxjs/operators";
import { ProductsService } from "./products.service";

@Injectable({
  providedIn: "root",
})
export class ProductResolverService implements Resolve<any> {
  constructor(
    private productService: ProductsService,
    private loadingCtrl: LoadingController
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    const id = route.params.id;
    return this.productService.getSingleProduct(id);
    // .pipe(
    //   tap(async () => {
    //     if (await this.loadingCtrl.getTop()) {
    //       this.loadingCtrl.dismiss().then();
    //     }
    //   })
    // );
  }
}
